import styled from 'styled-components';

export const DiagramContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 60rem;
  width: 100%;
`;
export const DiagramItem = styled.div`
  background-color: #fff;
  padding: 2.5rem 3rem;
  display: flex;
  line-height: 2.5rem;
  @media (max-width: 40rem){
    flex-direction: column;
    gap: 1rem;
  }
`;
export const ItemTitle = styled.div`
  color: #9c91bd;
  font-size: 1.25rem;
  flex: 0 0 14rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  @media (max-width: 40rem){
    flex: 0 0 auto;
  }
`;
export const ItemText = styled.div`
  line-height: 2;
  a {
    text-decoration: underline;
  }
`;
